import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getLatestNews } from 'actions/news.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'
import { reverseArray } from 'utils/reverseArray'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'

export interface LatestNewsProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useLatestNews = (props: LatestNewsProps) => {
  const dispatch = useAppDispatch()

  const latestNewsData = useSelector(
    (state: RootState) => state.news.latestNewsData
  )

  const selectedLanguage = getLanguageFromUrl()

  const animations = ['slideInRight', 'slideInUp', 'slideInLeft']
  const animationsReversed = reverseArray(animations)

  useEffect(() => {
    if (!latestNewsData) dispatch(getLatestNews())
  }, [latestNewsData])

  return {
    ...props,
    latestNewsData,
    animations,
    animationsReversed,
    selectedLanguage,
  }
}
